import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getTournamentDetail } from "../../api/tournaments";
import TournamentGalleryManager from "../../components/TournamentGalleryManager";
import { useAppSelector } from "../../store/store";
import { isPhotographer } from "../../utils/authorization";
import { Loader, PageHeader } from "../../ui";
import "./styles.scss";

const TournamentGalleryPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const hasFetched = useRef(false);
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  // Photographers can't open tournament detail; send them back to the galleries list.
  const backTarget = isPhotographer(currentUser) ? "/dashboard/galleries" : `/dashboard/tournaments/${id}`;

  const [loading, setLoading] = useState(true);
  const [tournamentName, setTournamentName] = useState("");

  const fetchData = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await getTournamentDetail(id);
      setTournamentName(res.data.name);
      document.title = `Gallery - ${res.data.name}`;
    } catch (error) {
      console.error("Error fetching tournament:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    fetchData();
  }, [id]);

  return (
    <div className="tournament-gallery-page">
      <PageHeader eyebrow={tournamentName} title="Gallery" back={{ onClick: () => navigate(backTarget), label: "Back" }} />

      {loading ? <Loader minHeight={400} /> : <TournamentGalleryManager tournamentName={tournamentName} />}
    </div>
  );
};

export default TournamentGalleryPage;
